import { Box, Grid, Tab, Tabs } from "@mui/material";
import Table from "./home/table";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  MdAccountBalanceWallet,
  MdAttachMoney,
  MdPayment,
  MdSwapHoriz,
} from "react-icons/md";
import EpaymentTransactionsTable from "../../../payments/transactions/home/table";
import EPaymentTransferTable from "./ePaymentTransfer";
import QiTransferPage from "../../../payments/qiTransfer";
import UserInfoCard from "./userInfoCard";
import FinancialInfoCard from "./financialInfoCard";

const Transactions = () => {
  const user = useSelector((state) => state.user.user.form);
  const isPos = user?.role === "pos";
  const [subTab, setSubTab] = useState(0);

  return (
    <Grid container spacing={2}>
      {isPos && (
        <Grid item xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={subTab}
              onChange={(e, newValue) => setSubTab(newValue)}
              aria-label="dejlah transactions tabs"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                minHeight: 40,
                "& .MuiTab-root": {
                  minHeight: 40,
                  py: 0.5,
                  px: 1.5,
                  minWidth: "auto",
                  fontSize: "0.8125rem",
                  textTransform: "none",
                },
              }}
            >
              <Tab
                icon={<MdAccountBalanceWallet size={18} />}
                iconPosition="start"
                label="المعاملات المالية"
              />
              <Tab
                icon={<MdSwapHoriz size={18} />}
                iconPosition="start"
                label="مناقلات الدفع الالكتروني"
              />
              <Tab
                icon={<MdPayment size={18} />}
                iconPosition="start"
                label="الدفع الالكتروني"
              />
              <Tab
                icon={<MdAttachMoney size={18} />}
                iconPosition="start"
                label="معاملات كي"
              />
            </Tabs>
          </Box>
        </Grid>
      )}

      <Grid item xs={12}>
        {/* Kept mounted so its state/data survive tab switches; hidden when the
            e-payment sub-tab is active. */}
        <Box sx={{ display: !isPos || subTab === 0 ? "block" : "none" }}>
          <Table />
        </Box>
        {isPos && subTab === 1 && <EPaymentTransferTable posId={user.pos_id} />}
        {isPos && subTab === 2 && (
          <EpaymentTransactionsTable posId={user.pos_id} />
        )}
        {isPos && subTab === 3 && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <UserInfoCard />
            </Grid>
            <Grid item xs={12} md={6}>
              <FinancialInfoCard />
            </Grid>
            <Grid item xs={12}>
              <QiTransferPage userId={user.id} />
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default Transactions;
